module.exports = __webpack_public_path__ + "static/media/LG_image.50080b96.mp3";